export enum ChartLineStyle {
    Solid = 'solid',
    Dashed = 'dashed',
    Dotted = 'dotted',
}

export enum ChartTooltipTrigger {
    Item = 'item',
    Axis = 'axis',
}

export interface IChartLegendCallbackParams {
    type: string;
    name: string;
    selected: Record<string, boolean>;
}
